import React from "react";
import { Helmet } from "react-helmet";

export const PIS = () => {
  return (
    <div className={"p-2 p-lg-5"}>
      <Helmet>
        <title>Portal Glampartners : Sobre o PIS</title>
      </Helmet>

      <h1>Sobre o PIS </h1>

      <h3>O que é?</h3>
      <div className={"gb-contentblock level-2 p-2 p-lg-5 mb-2"}>

        <p>
        O Programa de Integração Social (PIS) é uma contribuição social que as empresas fazem. O dinheiro dessa contribuição financia o pagamento do seguro desemprego e do abono salarial. Muitas vezes, ele aparece como PIS/PASEP ou NIT/PIS.
        </p>
      </div>

      <h3>Onde encontrar o meu PIS?</h3>

      <div className={"gb-contentblock level-2 p-2 p-lg-5 mb-2"}>

        <p>
          O número do PIS é o mesmo do NIS (Número de Identificação Social) e do NIT
          (Número de Identificação do Trabalhador). Os números podem ser encontrados em alguns documentos:
            <br /> <br />
            <ul>
              <li style={{ listStyle: 'inside' }}>Carteira de trabalho;</li>
              <li style={{ listStyle: 'inside' }}>Extrato do FGTS (Fundo de Garantia do Tempo de Serviço);</li>
              <li style={{ listStyle: 'inside' }}>Cartão Cidadão (só para PIS);</li>
              <li style={{ listStyle: 'inside' }}>Agência da Caixa, com documento oficial com foto (só para PIS);</li>
              <li style={{ listStyle: 'inside' }}>Agência do Banco do Brasil, com RG e CPF (só para Pasep);</li>
            </ul>

        </p>

        <p>
          Outra forma de conseguir os números é pelo site do
          <a href="https://cnisnet.inss.gov.br/cnisinternet/faces/pages/perfil.xhtml;jsessionid=v1g2hzvdp0QBTnXMKnHGdhL2p76YwTRQyH47XLJpSzwPd6hXX1QJ!-1219702089">
            &nbsp; <u>CNIS</u> &nbsp;
          </a>
          (Cadastro Nacional de Informações Sociais). Veja o passo a passo:
          <br /><br />

            <ul>
              <li><b>1.</b>  Acesse o site do
                <a href="https://cnisnet.inss.gov.br/cnisinternet/faces/pages/perfil.xhtml;jsessionid=v1g2hzvdp0QBTnXMKnHGdhL2p76YwTRQyH47XLJpSzwPd6hXX1QJ!-1219702089">
                  &nbsp; <u>CNIS;</u> &nbsp;
                </a>
              </li>
              <li> <b>2.</b>  Escolha o item "Cidadão";</li>
              <li> <b>3.</b>  No canto superior, à esquerda, clique em "Inscrição";</li>
              <li> <b>4.</b>  Escolha a opção "Filiado";</li>
              <li> <b>5.</b>  Preencha os campos em suas informações pessoais;</li>
              <li> <b>6.</b>  Após clicar em continuar, aparecerá uma faixa vermelha com o seu NIT. Esse é o seu número do PIS ou do Pasep.</li>
            </ul>

            </p>
      </div>
    </div>
  );
};
